import { RecentEntry } from './RecentTranslations.types';

// The last few drops, so a translation is never lost by leaving its page.
// ponytail: per browser (localStorage); list sets from the API (needs a location column on the set) if they must
// follow the user across devices.
const key = (businessId?: number | string) =>
  `importTranslations:${businessId}`;

export const readRecent = (businessId?: number | string): RecentEntry[] => {
  try {
    return JSON.parse(localStorage.getItem(key(businessId)) || '[]') || [];
  } catch {
    return [];
  }
};

export const saveRecent = (
  businessId: number | string | undefined,
  entry: RecentEntry
): void => {
  try {
    const list = [
      entry,
      ...readRecent(businessId).filter((item) => item.id !== entry.id),
    ].slice(0, 5);
    localStorage.setItem(key(businessId), JSON.stringify(list));
  } catch {
    // storage blocked: the set is still reachable from its own URL
  }
};
